import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import {
  MenuItem, SelectField, RaisedButton, Card, CardText, TextField, Drawer, Table, TableHeader, TableBody, TableRow, TableHeaderColumn,
  TableRowColumn, FlatButton, Dialog, CircularProgress
} from "material-ui";
import { Loading, ObtenerRecargosConvenidos, ShowTecniquesInExcep } from "./actions";
import ErrorSnack from "../../ErrorSnack/view";
import {
  ObtenerCentrosAtencion, ObtenerTiposArancel, ObtenerTiposPrestacion,
  CambiarTipoArancel, CambiarCentroAtencion, CambiarTipoPrestacion
} from "../../Global/actions";
import ConsultaRecargos from "../ConsultaRecargos/view";
import FiltroBusquedaDetalle from "../FiltroBusquedaDetalle/view";

import styles from "../../styles/styles";

class FiltroBusquedaRC extends React.Component {
  componentWillMount() {
    this.props.dispatch(ObtenerCentrosAtencion());
  }

  CambiarCentroAtencion = (event, index, value) => {
    this.props.dispatch(CambiarCentroAtencion(value));
    this.props.dispatch(ObtenerTiposPrestacion(value));
    this.props.dispatch(ObtenerTiposArancel(value));
  }

  CambiarTipoArancel = (event, index, value) => {
    this.props.dispatch(CambiarTipoArancel(value));
  }

  CambiarTipoPrestacion = (event, index, value) => {
    this.props.dispatch(CambiarTipoPrestacion(value));
  }

  closeTecniquesModal = () => this.props.dispatch(ShowTecniquesInExcep(false));

  BuscarRecargos = () => {
    this.props.dispatch(Loading(true));
    const filtroB = {
      RutArancel: this.props.filtros.tipoArancel,
      CentroAtencion: this.props.filtros.centroAtencion,
      GrupoPrestacion: this.props.filtros.tipoPrestacion || (this.props.tiposPrestaciones.filter((e) => e.Id > 0).length > 0 ?
        this.props.tiposPrestaciones.filter((e) => e.Id > 0)[0].Id : null),
    };
    this.props.dispatch(ObtenerRecargosConvenidos(filtroB));
  }

  render() {
    /*
      * @params
      * detailTecniques: object
      * @desc
      * Constante que recibe desde la grilla de recargos excepcionales para ver tecnicas asociadas
      * a un recargo excepcional. Esta posee los valores de las técnicas aplicadas.
    */

    const { detailTecniques } = this.props;

    //console.log('detailTecniques', detailTecniques)

    const menuListTipoArancel = [];
    // menuListTipoArancel.push((<MenuItem key={null} primaryText="Todos" value={null} />));
    if (this.props.tiposArancel) {
      this.props.tiposArancel.forEach((element) => {
        menuListTipoArancel.push(<MenuItem key={element.Rut} value={element.Rut} primaryText={element.Descripcion} style={styles.customWidthItem} />);
      });
    }

    const menuListCentroAtencion = [];
    // menuListCentroAtencion.push((<MenuItem key={null} primaryText="Todos" value={null} />));
    if (this.props.centrosAtencion) {
      this.props.centrosAtencion.forEach((element) => {
        menuListCentroAtencion.push(<MenuItem key={element.Secuencia} value={element.Secuencia} primaryText={element.Descripcion} style={styles.customWidthItem} />);
      });
    }

    const menuListTipoPrestaciones = [];
    let menuListTipoPrestacionesDefault = null;
    if (this.props.tiposPrestaciones && this.props.tiposPrestaciones.length > 0) {
      menuListTipoPrestacionesDefault = this.props.tiposPrestaciones.filter((e) => e.Id > 0).length > 0 ?
        this.props.tiposPrestaciones.filter((e) => e.Id > 0)[0].Id : null;
      this.props.tiposPrestaciones.forEach((element) => {
        if (element.Id > 0) {
          menuListTipoPrestaciones
            .push(<MenuItem key={element.Id} value={element.Id} primaryText={`${element.TipoAtencion}: ${element.Descripcion}`} style={styles.customWidthItem} />);
        }
      });
    }

    return (
      <div>

        {this.props.token ?

          <div>
            <div style={styles.frameContenidoGeneral}>
              <Card zDepth={0} style={{ paddingBottom: 0 }}>
                <CardText style={{ paddingBottom: 0 }}>
                  <div className="row" style={{ paddingBottom: 0 }}>
                    {/* <div class="menu" style={{margin:0, padding:0, width:40}}>
                  <IconButton onClick={this.handleToggle}  iconStyle={styles.svgMenuStyleResultado} style={styles.iconMenuStyle}>
                      <MenuIcon />
                  </IconButton>
                  <Drawer
                  style={{
                    zIndex: 999,
                  }}
                  docked={false}
                  width={235}
                  open={this.state.open}
                  onRequestChange={(open) => this.setState({open})}
                  zDepth={0}
                  containerStyle={{height:550, border:"1px solid #212121", margin:5}}
                  overlayStyle={{backgroundColor: 'rgba(255,255,255,0)'}}
                  >
                  Aquí va el menú
                  </Drawer>
                </div> */}
                    <div className="contenido" style={{ margin: 0, padding: 0, width: 925 }}>
                      <div style={styles.h1}>Consulta de Recargos Convenidos
                      </div>
                      <div style={styles.h2}>Seleccione el centro de atención y tipo de arancel que desea consultar.
                      </div>
                    </div>
                  </div>
                  {
                    this.props.tiposArancel && this.props.tiposArancel.length > 0 &&
                      this.props.centrosAtencion && this.props.centrosAtencion.length > 0 &&
                      this.props.tiposPrestaciones && this.props.tiposPrestaciones.length > 0 ?
                      <div>
                        <div className="row">
                          <div className="col-5" style={styles.colSelectFieldActualizar}>
                            <div style={styles.floatingClaseSelect}>Rut Institución</div>
                            <TextField
                              name="txt_fbrc_rutinstitucion"
                              id="txt_fbrc_rutinstitucion"
                              value={this.props.rutInstitucion}
                              onChange={this.CambiarCodFonasa}
                              maxLength={50}
                              underlineStyle={styles.underlineSelectField}
                              inputStyle={styles.h4}
                              style={styles.selectFiledStyleRecargosConvenios}
                            />
                          </div>
                          <div className="col-5" style={styles.colSelectFieldActualizar}>
                            <div style={styles.floatingClaseSelect}>Centro de Atención</div>
                            <SelectField
                              name="dd_fbrc_centroatencion"
                              id="dd_fbrc_centroatencion"
                              value={this.props.filtros.centroAtencion}
                              onChange={this.CambiarCentroAtencion}
                              labelStyle={styles.h4}
                              underlineStyle={styles.underlineSelectField}
                              style={styles.selectFiledStyleRecargosConvenios}
                              iconStyle={styles.iconSelectField}
                              menuItemStyle={styles.menuItemStyleSelectField}
                              selectedMenuItemStyle={styles.selectedMenuItemSelectField}
                            >
                              {menuListCentroAtencion}
                            </SelectField>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-5" style={styles.colSelectFieldActualizar}>
                            <div style={styles.floatingClaseSelect2}>Tipo de Arancel</div>
                            <SelectField
                              name="dd_fbrc_tipoarancel"
                              id="dd_fbrc_tipoarancel"
                              value={this.props.filtros.tipoArancel}
                              onChange={this.CambiarTipoArancel}
                              labelStyle={styles.h4}
                              underlineStyle={styles.underlineSelectField}
                              style={styles.selectFiledStyleRecargosConvenios}
                              iconStyle={styles.iconSelectField}
                              menuItemStyle={styles.menuItemStyleSelectField}
                              selectedMenuItemStyle={styles.selectedMenuItemSelectField}
                            >
                              {menuListTipoArancel}
                            </SelectField>
                          </div>
                          <div className="col-5" style={styles.colSelectFieldActualizar}>
                            <div style={styles.floatingClaseSelect2}>Tipo de Prestación</div>
                            <SelectField
                              name="dd_fbrc_tipoprestacion"
                              id="dd_fbrc_tipoprestacion"
                              value={this.props.filtros.tipoPrestacion || menuListTipoPrestacionesDefault}
                              onChange={this.CambiarTipoPrestacion}
                              labelStyle={styles.h4}
                              underlineStyle={styles.underlineSelectField}
                              style={styles.selectFiledStyleRecargosConvenios}
                              iconStyle={styles.iconSelectField}
                              menuItemStyle={styles.menuItemStyleSelectField}
                              selectedMenuItemStyle={styles.selectedMenuItemSelectField}
                            >
                              {menuListTipoPrestaciones}
                            </SelectField>
                          </div>
                          <div className="col-2" style={styles.colBotonBusquedaRecargos}>
                            {!this.props.loading ?
                              <RaisedButton
                                label="Consultar"
                                onClick={this.BuscarRecargos}
                                secondary
                                labelStyle={{ fontSize: "11px" }}
                                overlayStyle={{ borderRadius: 5 }}
                                rippleStyle={{ borderRadius: 5 }}
                                style={{ width: "130px", borderRadius: 5, marginLeft: 20 }}
                                buttonStyle={{ borderRadius: 5 }}
                              />
                              :
                              <RaisedButton
                                label="Cargando ..."
                                secondary
                                labelStyle={{ fontSize: "11px" }}
                                overlayStyle={{ borderRadius: 5 }}
                                rippleStyle={{ borderRadius: 5 }}
                                style={{ width: "130px", borderRadius: 5, marginLeft: 20 }}
                                buttonStyle={{ borderRadius: 5 }}

                              />
                            }
                          </div>
                        </div>
                      </div>
                      :
                      <CircularProgress />
                  }
                </CardText>
              </Card>
            </div>
            {this.props.busquedarecargos ?
              <ConsultaRecargos />
              : null}

            <Drawer
              width="98%"
              openSecondary
              open={this.props.modalFiltroBusquedaDetalle}
              docked={false}
            >
              {this.props.modalFiltroBusquedaDetalle ?
                <FiltroBusquedaDetalle />
                : null}
            </Drawer>

            <Dialog
              open={this.props.modalShowTecniques}
              modal
              actions={
                <FlatButton
                  label="Cerrar"
                  primary
                  onClick={this.closeTecniquesModal}
                />
              }
              style={{ width: "700px", fontSize: "12px" }}
              autoDetectWindowHeight={true}
              autoScrollBodyContent={true}
              repositionOnUpdate={true}
              contentStyle={{ width: '90%', height: '90%' }}
            >
              {this.props.modalShowTecniques ?
                <Table
                  key="showTecniquesTable"
                  fixedHeader
                  fixedFooter
                  selectable={false}
                >
                  <TableHeader adjustForCheckbox={false} displaySelectAll={false} >
                    <TableRow selectable={false}>
                      <TableHeaderColumn style={styles.tituloTablaRecargos1}>Tipo de Tecnica</TableHeaderColumn>
                      <TableHeaderColumn style={styles.tituloTablaRecargos2}>Ambulatorio</TableHeaderColumn>
                      <TableHeaderColumn style={styles.tituloTablaRecargos3}>Hospitalario</TableHeaderColumn>
                    </TableRow>
                  </TableHeader>
                  <TableBody
                    displayRowCheckbox={false}
                    deselectOnClickaway={false}
                    showRowHover
                    stripedRows={false}
                    style={{ overflow: "scroll" }}
                  >
                    {
                      (
                        (typeof detailTecniques['amb']['Tradicional'] !== 'undefined' && detailTecniques['amb']['Tradicional']) ||
                        (typeof detailTecniques['hosp']['Tradicional'] !== 'undefined' && detailTecniques['hosp']['Tradicional'])
                      ) ?
                        <TableRow key="tradicional">
                          <TableRowColumn style={styles.tituloTablaRecargos1}>Tradicional</TableRowColumn>
                          <TableRowColumn style={styles.contTablaRecargos2}>
                            {
                              this.props.detailTecniques['amb']['Tradicional'] ?
                                this.props.detailTecniques['amb']['Tradicional']
                                :
                                '-'
                            }
                          </TableRowColumn>
                          <TableRowColumn style={styles.contTablaRecargos3}>
                            {
                              this.props.detailTecniques['hosp']['Tradicional'] ?
                                this.props.detailTecniques['hosp']['Tradicional']
                                :
                                '-'
                            }
                          </TableRowColumn>
                        </TableRow>
                        :
                        null
                    }

                    {
                      (
                        (typeof detailTecniques['amb']['Radiocirugia'] !== 'undefined' && detailTecniques['amb']['Radiocirugia']) ||
                        (typeof detailTecniques['hosp']['Radiocirugia'] !== 'undefined' && detailTecniques['hosp']['Radiocirugia'])
                      ) ?
                        <TableRow key="radiocirugia">
                          <TableRowColumn style={styles.tituloTablaRecargos1}>Radiocirugia</TableRowColumn>
                          <TableRowColumn style={styles.contTablaRecargos2}>{this.props.detailTecniques['amb']['Radiocirugia'] ? this.props.detailTecniques['amb']['Radiocirugia'] : '-'}</TableRowColumn>
                          <TableRowColumn style={styles.contTablaRecargos3}>{this.props.detailTecniques['hosp']['Radiocirugia'] ? this.props.detailTecniques['hosp']['Radiocirugia'] : '-'}</TableRowColumn>
                        </TableRow>
                        :
                        null
                    }

                    {
                      (
                        (typeof detailTecniques['amb']['Endoscopia'] !== 'undefined' && detailTecniques['amb']['Endoscopia']) ||
                        (typeof detailTecniques['hosp']['Endoscopia'] !== 'undefined' && detailTecniques['hosp']['Endoscopia'])
                      ) ?
                        <TableRow key="endoscopia">
                          <TableRowColumn style={styles.tituloTablaRecargos1}>Endoscopia</TableRowColumn>
                          <TableRowColumn style={styles.contTablaRecargos2}>{this.props.detailTecniques['amb']['Endoscopia'] ? this.props.detailTecniques['amb']['Endoscopia'] : '-'}</TableRowColumn>
                          <TableRowColumn style={styles.contTablaRecargos3}>{this.props.detailTecniques['hosp']['Endoscopia'] ? this.props.detailTecniques['hosp']['Endoscopia'] : '-'}</TableRowColumn>
                        </TableRow>
                        :
                        null
                    }

                    {
                      (
                        (typeof detailTecniques['amb']['Esterotaxica'] !== 'undefined' && detailTecniques['amb']['Esterotaxica']) ||
                        (typeof detailTecniques['hosp']['Esterotaxica'] !== 'undefined' && detailTecniques['hosp']['Esterotaxica'])
                      ) ?
                        <TableRow key="esterotaxica">
                          <TableRowColumn style={styles.tituloTablaRecargos1}>Esterotaxica</TableRowColumn>
                          <TableRowColumn style={styles.contTablaRecargos2}>{this.props.detailTecniques['amb']['Esterotaxica'] ? this.props.detailTecniques['amb']['Esterotaxica'] : '-'}</TableRowColumn>
                          <TableRowColumn style={styles.contTablaRecargos3}>{this.props.detailTecniques['hosp']['Esterotaxica'] ? this.props.detailTecniques['hosp']['Esterotaxica'] : '-'}</TableRowColumn>
                        </TableRow>
                        :
                        null
                    }

                    {
                      (
                        (typeof detailTecniques['amb']['Termoterapia'] !== 'undefined' && detailTecniques['amb']['Termoterapia']) ||
                        (typeof detailTecniques['hosp']['Termoterapia'] !== 'undefined' && detailTecniques['hosp']['Termoterapia'])
                      ) ?
                        <TableRow key="termoterapia">
                          <TableRowColumn style={styles.tituloTablaRecargos1}>Termoterapia</TableRowColumn>
                          <TableRowColumn style={styles.contTablaRecargos2}>{this.props.detailTecniques['amb']['Termoterapia'] ? this.props.detailTecniques['amb']['Termoterapia'] : '-'}</TableRowColumn>
                          <TableRowColumn style={styles.contTablaRecargos3}>{this.props.detailTecniques['hosp']['Termoterapia'] ? this.props.detailTecniques['hosp']['Termoterapia'] : '-'}</TableRowColumn>
                        </TableRow>
                        :
                        null
                    }

                    {
                      (
                        (typeof detailTecniques['amb']['Microscopica'] !== 'undefined' && detailTecniques['amb']['Microscopica']) ||
                        (typeof detailTecniques['hosp']['Microscopica'] !== 'undefined' && detailTecniques['hosp']['Microscopica'])
                      ) ?
                        <TableRow key="microscopica">
                          <TableRowColumn style={styles.tituloTablaRecargos1}>Microscopica</TableRowColumn>
                          <TableRowColumn style={styles.contTablaRecargos2}>{this.props.detailTecniques['amb']['Microscopica'] ? this.props.detailTecniques['amb']['Microscopica'] : '-'}</TableRowColumn>
                          <TableRowColumn style={styles.contTablaRecargos3}>{this.props.detailTecniques['hosp']['Microscopica'] ? this.props.detailTecniques['hosp']['Microscopica'] : '-'}</TableRowColumn>
                        </TableRow>
                        :
                        null
                    }

                    {
                      (
                        (typeof detailTecniques['amb']['Lasik'] !== 'undefined' && detailTecniques['amb']['Lasik']) ||
                        (typeof detailTecniques['hosp']['Lasik'] !== 'undefined' && detailTecniques['hosp']['Lasik'])
                      ) ?
                        <TableRow key="lasik">
                          <TableRowColumn style={styles.tituloTablaRecargos1}>Lasik</TableRowColumn>
                          <TableRowColumn style={styles.contTablaRecargos2}>{this.props.detailTecniques['amb']['Lasik'] ? this.props.detailTecniques['amb']['Lasik'] : '-'}</TableRowColumn>
                          <TableRowColumn style={styles.contTablaRecargos3}>{this.props.detailTecniques['hosp']['Lasik'] ? this.props.detailTecniques['hosp']['Lasik'] : '-'}</TableRowColumn>
                        </TableRow>
                        :
                        null
                    }

                    {
                      (
                        (typeof detailTecniques['amb']['Rayo Laser'] !== 'undefined' && detailTecniques['amb']['Rayo Laser']) ||
                        (typeof detailTecniques['hosp']['Rayo Laser'] !== 'undefined' && detailTecniques['hosp']['Rayo Laser'])
                      ) ?
                        <TableRow key="rayoLaser">
                          <TableRowColumn style={styles.tituloTablaRecargos1}>Rayo Laser</TableRowColumn>
                          <TableRowColumn style={styles.contTablaRecargos2}>{this.props.detailTecniques['amb']['Rayo Laser'] ? this.props.detailTecniques['amb']['Rayo Laser'] : '-'}</TableRowColumn>
                          <TableRowColumn style={styles.contTablaRecargos3}>{this.props.detailTecniques['hosp']['Rayo Laser'] ? this.props.detailTecniques['hosp']['Rayo Laser'] : '-'}</TableRowColumn>
                        </TableRow>
                        :
                        null
                    }

                    {
                      (
                        (typeof detailTecniques['amb']['Video Laparoscopica'] !== 'undefined' && detailTecniques['amb']['Video Laparoscopica']) ||
                        (typeof detailTecniques['hosp']['Video Laparoscopica'] !== 'undefined' && detailTecniques['hosp']['Video Laparoscopica'])
                      ) ?
                        <TableRow key="videoLaparoscopica">
                          <TableRowColumn style={styles.tituloTablaRecargos1}>Video Laparoscopica</TableRowColumn>
                          <TableRowColumn style={styles.contTablaRecargos2}>{this.props.detailTecniques['amb']['Video Laparoscopica'] ? this.props.detailTecniques['amb']['Video Laparoscopica'] : '-'}</TableRowColumn>
                          <TableRowColumn style={styles.contTablaRecargos3}>{this.props.detailTecniques['hosp']['Video Laparoscopica'] ? this.props.detailTecniques['hosp']['Video Laparoscopica'] : '-'}</TableRowColumn>
                        </TableRow>
                        :
                        null
                    }

                    {
                      (
                        (typeof detailTecniques['amb']['Endovascular'] !== 'undefined' && detailTecniques['amb']['Endovascular']) ||
                        (typeof detailTecniques['hosp']['Endovascular'] !== 'undefined' && detailTecniques['hosp']['Endovascular'])
                      ) ?
                        <TableRow key="endovascular">
                          <TableRowColumn style={styles.tituloTablaRecargos1}>Endovascular</TableRowColumn>
                          <TableRowColumn style={styles.contTablaRecargos2}>{this.props.detailTecniques['amb']['Endovascular'] ? this.props.detailTecniques['amb']['Endovascular'] : '-'}</TableRowColumn>
                          <TableRowColumn style={styles.contTablaRecargos3}>{this.props.detailTecniques['hosp']['Endovascular'] ? this.props.detailTecniques['hosp']['Endovascular'] : '-'}</TableRowColumn>
                        </TableRow>
                        :
                        null
                    }

                  </TableBody>
                </Table>
                : null}
            </Dialog>

            <ErrorSnack />
          </div>
          :
          null}
      </div>
    );
  }
}

FiltroBusquedaRC.propTypes = {
  loading: PropTypes.bool.isRequired,
  busquedarecargos: PropTypes.bool.isRequired,
  rutInstitucion: PropTypes.number.isRequired,
  tiposArancel: PropTypes.array.isRequired,
  centrosAtencion: PropTypes.array.isRequired,
  tiposPrestaciones: PropTypes.array.isRequired,
  filtros: PropTypes.any.isRequired,
  modalFiltroBusquedaDetalle: PropTypes.bool.isRequired,
  modalShowTecniques: PropTypes.bool.isRequired,
  detailTecniques: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
  token: PropTypes.string.isRequired,
};

const mapStateToProps = (state) => ({
  loading: state.filtroBusquedaRC.loading,
  busquedarecargos: state.filtroBusquedaRC.busquedarecargos,
  rutInstitucion: state.global.rutInstitucion,
  tiposArancel: state.global.filtros_CAT.tiposArancel,
  centrosAtencion: state.global.filtros_CAT.centrosAtencion,
  tiposPrestaciones: state.global.filtros_CAT.tiposPrestaciones,
  filtros: {
    tipoArancel: state.global.filtros_CAT.tipoArancel,
    centroAtencion: state.global.filtros_CAT.centroAtencion,
    tipoPrestacion: state.global.filtros_CAT.tipoPrestacion,
  },
  modalFiltroBusquedaDetalle: state.filtroBusquedaRC.modalFiltroBusquedaDetalle,
  modalShowTecniques: state.filtroBusquedaRC.modalShowTecniques,
  detailTecniques: state.filtroBusquedaRC.detailTecniques,
  token: state.global.token,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});


export default connect(mapStateToProps, mapDispatchToProps)(FiltroBusquedaRC);

